export default {
  pageTitle: 'Fasilitas',
  metaDescription: 'Jelajahi fasilitas dan peralatan manufaktur TEF, termasuk mesin potong, pembentuk, las, dan alat angkat berat yang mendukung proyek fabrikasi skala besar.',
  hero: { title: 'Fasilitas' },
  manufacturing: {
    heading: 'Fasilitas Produksi',
    intro:
      'TEF mengoperasikan fasilitas produksi canggih yang dilengkapi teknologi mutakhir untuk memastikan efisiensi dan presisi dalam produksi.',
    table: {
      headers: {
        tools: 'PERALATAN',
        dsc: 'DSC',
        edv: 'EDV',
        vyg: 'VYG',
        quantity: 'JUMLAH',
      },
      rows: {
        crane: 'Crane',
        hydraulicPress: 'Mesin Hydraulic Press',
        ncPressBreak: 'Mesin NC Press Break',
        rollsBending: 'Mesin Rolls Bending Rolling',
        pipeBending: 'Mesin Pembengkok Pipa/Profil',
        weldingMachines: 'Mesin Las',
        cuttingMachines: 'Mesin Potong',
        machineTools: 'Mesin Perkakas',
        mobileGenset: 'Genset Mobile & Kompresor Mobile',
        inspectionTools: 'Peralatan Inspeksi',
        forklift: 'Forklift, Mobile Crane & Truck Crane',
      },
    },
    maxSize: {
      note: 'Ukuran maksimum produk fabrikasi dibatasi oleh sarana transportasi darat.',
      maxDiameterLabel: 'Diameter maksimum',
      maxDiameterValue: '6 meter',
      maxLengthLabel: 'Panjang maksimum',
      maxLengthValue: 'kurang lebih 30 meter',
      overLimitNote: 'Produk dengan ukuran melebihi batas maksimum dapat dinegosiasikan.',
    },
  },
};
